/* import __COLOCATED_TEMPLATE__ from './prevent-replies.hbs'; */
/* RESPONSIBLE TEAM: team-standalone */
import Component from '@glimmer/component';
import { action } from '@ember/object';
import type VisibilityModel from 'embercom/models/messenger-settings/visibility';

type VisibilitySettings = InstanceType<typeof VisibilityModel> & {
  set(key: string, value: boolean): void;
};

interface Args {
  visibilitySettings: VisibilitySettings;
}

export default class PreventReplies extends Component<Args> {
  @action
  toggleProperty(
    property:
      | 'noContinuedConversationsEnabledForVisitors'
      | 'noContinuedConversationsEnabledForUsers',
  ) {
    if (this.args.visibilitySettings) {
      this.args.visibilitySettings.set(property, !this.args.visibilitySettings[property]);
    }
  }
}

declare module '@glint/environment-ember-loose/registry' {
  export default interface Registry {
    'MessengerSettings::Content::PreventReplies': typeof PreventReplies;
    'messenger-settings/content/prevent-replies': typeof PreventReplies;
  }
}
